import React from "react";
import Text from "@/components/ui/text";
import { cn } from "@/utils/utils";
import MismatchSource from "@/components/controls/Questions/DreamerIndication/components/MismatchIndication/MismatchSource";

export type mismatchMode = "current" | "dreamer";

interface Props {
  title: string;
  /** Label of the collapsible citation; only shown in dreamer mode. */
  sourceLabel: string;
  value: string;
  citation?: string;
  mode?: mismatchMode;
  footerActions?: JSX.Element;
}

const MismatchSection: React.FC<Props> = ({
  title,
  sourceLabel,
  value,
  citation,
  mode = "current",
  footerActions = null
}) => {
  return (
    <div
      className={cn(
        "flex-1 p-2 rounded-lg flex flex-col gap-2",
        mode === "current" ? "bg-surface-mismatch-current" : ""
      )}
      style={
        mode === "dreamer"
          ? {
              background:
                "linear-gradient(84deg, var(--surface-mismatch-dreamer-sheen-start) 66.48%, var(--surface-mismatch-dreamer-sheen-end) 107.08%), radial-gradient(201.81% 107.21% at -3.68% 109.11%, var(--surface-mismatch-dreamer-glow-start) 0%, var(--surface-mismatch-dreamer-glow-end) 100%)"
            }
          : undefined
      }
    >
      <Text variant="smBody">{title}</Text>
      <div className="p-2 rounded-lg border border-border-field-default">
        <Text
          variant={mode === "dreamer" ? "body" : "bodySecondary"}
          className={mode === "dreamer" ? "italic" : ""}
        >
          {value}
        </Text>
      </div>
      {mode === "dreamer" && (
        <MismatchSource label={sourceLabel} citation={citation} />
      )}
      {footerActions}
    </div>
  );
};

export default MismatchSection;
